const CTF_IMAGES_BASE = 'https://images.ctfassets.net/wjuty07n9kzp'

const buildIcon = (assetPath, width, height, title) => ({
  title,
  file: {
    url: `${CTF_IMAGES_BASE}/${assetPath}`,
    details: { image: { width, height } },
  },
})

/** Same Contentful assets used by K8 admin quick links. */
export const K8_ADMIN_QUICK_LINK_ICON_DEFAULTS = {
  implementation: buildIcon(
    '77I1hhhdxXxzCr8JwogC4a/51c2f76f82fee717b511fa98b6a7fc2c/ss_icon_implementation.svg',
    18,
    17,
    'ss icon implementation',
  ),
  reports: buildIcon(
    '5WT32rRKISdSZTHYoYqLWI/c939c1aaa085c0a74da358a193fb83db/ss_icon_reports.svg',
    17,
    17,
    'ss icon reports',
  ),
  explore: buildIcon(
    '5IetoFYQ3ZhiimbEr44wa3/1c30df58adba686ab9a74c79204ac8e4/ss_icon_explorelessons.svg',
    23,
    17,
    'ss icon explorelessons',
  ),
}

const normalizeIconAssetUrl = icon => {
  const url = icon?.file?.url
  if (!url || typeof url !== 'string') return icon
  if (!url.startsWith('//')) return icon

  return {
    ...icon,
    file: {
      ...icon.file,
      url: `https:${url}`,
    },
  }
}

const pickIconFromSupportLinks = (supportLinks, predicate, fallbackKey) => {
  const match = supportLinks?.find(predicate)
  const icon = match?.icon
  if (icon?.file?.url) {
    return normalizeIconAssetUrl(icon)
  }
  return K8_ADMIN_QUICK_LINK_ICON_DEFAULTS[fallbackKey]
}

/**
 * Icons for admin banner quick links (Implementation Supports, Explore Lessons,
 * Lesson Completion Report). Prefer K8 entries from Contentful when loaded.
 *
 * TODO: Standalone DWB should load full quick links (not just icons) from a DWB
 * Contentful adminProgramLinks entry via findProgramLinks, same as K8/HS/BPU/CPU.
 */
export const getK8AdminQuickLinkIcons = programQuickLinks => {
  const k8QuickLinksEntry = programQuickLinks?.find(
    entry => entry?.internalTitle === 'k8 admin quick links',
  )
  const supportLinks = k8QuickLinksEntry?.supportLinks

  if (!Array.isArray(supportLinks) || supportLinks.length === 0) {
    return K8_ADMIN_QUICK_LINK_ICON_DEFAULTS
  }

  return {
    implementation: pickIconFromSupportLinks(
      supportLinks,
      link => link.displayTitle === 'Implementation Supports',
      'implementation',
    ),
    reports: pickIconFromSupportLinks(
      supportLinks,
      link => link.buttonText === 'Lesson Completion Report',
      'reports',
    ),
    explore: pickIconFromSupportLinks(
      supportLinks,
      link => link.displayTitle === 'Explore Lessons',
      'explore',
    ),
  }
}
